import { request, chatbotUrl}  from '../utils/request';
import {APP_CONFIG} from '../utils/config';

export function getEvent(data) {
    const requestUrl = chatbotUrl(data.isDev) + APP_CONFIG.getEvent;
	let param = {
		projectId : data.config.projectId
	}
    return request(requestUrl, 'post', param);
}

export function wirteEvent(data) {
    const requestUrl = chatbotUrl(data.isDev) + APP_CONFIG.writeEvent;

    return request(requestUrl, 'post', data);
}

export function getFeedback(data) {
    const requestUrl = chatbotUrl(data.isDev) + APP_CONFIG.getFeedback;
	let param = {
		projectId : data.config.projectId
	}
    return request(requestUrl, 'post', param);
}

export function wirteFeedback(data) {
    const requestUrl = chatbotUrl(data.isDev) + APP_CONFIG.writeFeedback;

    return request(requestUrl, 'post', data);
}